<tr (click)="onToggle()" class="jit-tr-content" [class.expanded]="expanded">
  <ng-content select="[content]"></ng-content>
</tr>
<tr class="jit-tr-expand" [class.expanded]="expanded">
  <td class="jit-tr-expand__td" [colSpan]="colspan">
    <div class="jit-tr-expand__wrap" [class.expanded]="expanded">
      <ng-content select="[expanded]"></ng-content>
    </div>
  </td>
</tr>